import { combineReducers } from 'redux';
import signin from './modules/signin';
import MSRPReducer from './modules/msrp';
import user from './modules/user';
import search from './modules/search';
import categories from './modules/categories';
import pagination from './modules/pagination';
import model from './modules/model';
import cart from './modules/cart';
import locale from './modules/locale';
import checkout from './modules/checkout';
import orders from './modules/orders';
import lists from './modules/lists';
import invoices from './modules/invoices';
import warranty from './modules/warranty';
import accountView from './modules/accountview';
import dashboardView from './modules/dashboardview';
import addresses from './modules/addresses';
import tracking from './modules/trackingInfo';
import creditcard from './modules/creditcard';
import paySimpleCheckoutToken from './modules/paysimplecheckouttoken';
import paySimplePayment from './modules/paysimplepayment';
import payments from './modules/payments';
import credits from './modules/credits';
import returns from './modules/returns';
import arSummary from './modules/arSummary';
import monthlyStatement from './modules/monthlyStatement';
import samsungOrderInvoiceView from './modules/samsungOrderInvoice';
import googleAnalytics from '../analytics/store';

export default combineReducers({
  locale,
  signin,
  msrp: MSRPReducer,
  user,
  arSummary,
  search,
  categories,
  model,
  pagination,
  cart,
  checkout,
  creditcard,
  orders,
  lists,
  warranty,
  invoices,
  accountView,
  dashboardView,
  addresses,
  tracking,
  paySimpleCheckoutToken,
  paySimplePayment,
  payments,
  credits,
  returns,
  monthlyStatement,
  samsungOrderInvoiceView,
  googleAnalytics
});
